import { WireItemType } from 'scenes/common/api/quote/types';
import { removeDoubleSpace } from 'scenes/common/helpers/string';
import { hasContentsCoverType } from 'scenes/home/selectors';
import {
  HomeFunnelState,
  SpecifiedContent,
  SpecifiedContentCover,
} from 'scenes/home/types';

import { WireCoverageItem } from '../types';

const shouldMapItems = (state: HomeFunnelState) => hasContentsCoverType(state);

const mapPortableContents = (specifiedContents?: SpecifiedContent[]) =>
  specifiedContents && specifiedContents.length > 0
    ? [
        {
          name: WireItemType.SpecifiedPortables,
          selected: true,
          list: specifiedContents.map((item) => ({
            category: item.category,
            // TODO: Remove once backend solution implemented
            description: removeDoubleSpace(item.description),
            isOutOfHome: item.cover === SpecifiedContentCover.PortableContents,
            value: Number(item.itemValue),
            cost: 0,
          })),
        },
      ]
    : [];

const mapUnspecifiedPortableContents = (unspecifiedPortablesValue?: string) =>
  unspecifiedPortablesValue
    ? [
        {
          name: WireItemType.GeneralPortables,
          selected: true,
          list: [{ value: Number(unspecifiedPortablesValue) }],
        },
      ]
    : [
        {
          name: WireItemType.GeneralPortables,
          selected: false,
          list: [],
        },
      ];

export const toWireItems = (
  state: HomeFunnelState,
  specifiedContents?: SpecifiedContent[],
  unspecifiedPortablesValue?: string
): WireCoverageItem[] | undefined =>
  shouldMapItems(state)
    ? [
        ...mapPortableContents(specifiedContents),
        ...mapUnspecifiedPortableContents(unspecifiedPortablesValue),
      ]
    : undefined;
